import Api from '../../../../shared/Api';

class SinglePhotographerInvoiceApi {
    static getPhotographerInvoiceFilter(employedPhotographers: boolean): any {
        return new Api().get(
            `/views/photographer-invoice/filter?employedPhotographers=${employedPhotographers}`
        );
    }

    static getLists(photographerId: number): any {
        return new Api().get(`/views/photographer-invoice/list/${photographerId}`);
    }

    static getPendingInvoice(
        photographerId: number,
        invoiceNumber: string,
        year: number,
        month: number
    ): any {
        return new Api().put(`/views/photographer-invoice/pending/${photographerId}`, {
            invoiceNumber,
            year,
            month
        });
    }

    static savePendingInvoice(invoiceNumber: string, checksum: number): any {
        return new Api().post(`/views/photographer-invoice`, {
            invoiceNumber,
            checksum
        });
    }

    static getPreviewInvoice(photographerId: number): any {
        return new Api().get(`/views/photographer-invoice/preview/${photographerId}`);
    }

    static getHistoricInvoice(photographerId: number, invoiceId: number): any {
        return new Api().get(`/views/photographer-invoice/historic/${photographerId}/${invoiceId}`);
    }

    static getHistoricEmployedInvoice(photographerId: number, year: number, month: number): any {
        return new Api().get(`/views/photographer-invoice/historic/${photographerId}/employed`, {
            year,
            month
        });
    }

    static rejectPendingInvoice(
        photographerId: number,
        year: number,
        month: number,
        day: number,
        rejectMessage: string
    ): any {
        return new Api().post(
            `/views/photographer-invoice/${photographerId}/${year}/${month}/${day}`,
            { rejectMessage }
        );
    }

    static getRejectedInvoice(
        photographerId: number,
        year: number,
        month: number,
        day: number
    ): any {
        return new Api().get(
            `/views/photographer-invoice/rejected/${photographerId}/${year}/${month}/${day}`
        );
    }

    static unlockRejectedInvoice(
        photographerId: number,
        swedishYear: number,
        swedishMonth: number,
        swedishDay: number
    ): any {
        return new Api().put('/views/photographer-invoice/unlock', {
            photographerId,
            swedishYear,
            swedishMonth,
            swedishDay
        });
    }
}

export default SinglePhotographerInvoiceApi;
